module.exports = __webpack_public_path__ + "static/media/capa_05.50e5e9fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/capa_05.jpg
// module id = 80
// module chunks = 0